<section class="flex flex-auto justify-center w-full bg-red-400">
    <div class="w-full">
        <div class="min-h-screen bg-cover bg-center bg-no-repeat bg-white/90 bg-blend-lighten p-8"
            style="background-image: url('https://images.pexels.com/photos/18499110/pexels-photo-18499110.jpeg')">
            <div class="w-full mx-auto bg-white/80 backdrop-blur-md rounded-lg shadow-md p-10">
                <h1 class="text-3xl font-bold text-primary-600 mb-2">CIC Hotel Booking Request</h1>
                <p class="text-sm mb-6 text-gray-700">CIC Hotel Booking Request for Namibia accommodation</p>

                <form class="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm" (ngSubmit)="submitBookingRequest()"
                    #bookingForm="ngForm">
                    <!-- Person requesting booking -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Name of Person requesting booking *</label>
                        <select class="w-full mt-1 border border-gray-300 text-gray-400 rounded p-2"
                            name="personRequesting" [ngClass]="{
                            'text-gray-400': view.bookingForm.personRequesting === '',
                            'text-black': view.bookingForm.personRequesting !== ''
                             }" [(ngModel)]="view.bookingForm.personRequesting">
                            <option value="">Select Person</option>
                            @for(person of allBookingPersons; track person) {
                            <option [value]="person.firstName + ' ' + person.lastName">
                                {{ person.firstName }} {{ person.lastName }}
                            </option>
                            }
                        </select>
                    </div>

                    <!-- Additional searchable option -->
                    <!-- <div> -->
                    <!-- <label class="block text-red-700 font-semibold">Name of Person requesting booking *</label> -->

                    <!-- Search input -->
                    <!-- <input type="text" placeholder="Search name..." class="w-full mt-1 mb-2 border rounded p-2"
                        (input)="onSearchChange($event.target.value)" /> -->

                    <!-- Filtered select -->
                    <!-- <select class="w-full border rounded p-2">
                        @for(person of filteredBookingPersons; track person){
                            <option
                                [value]="person.firstName + ' ' + person.lastName">
                                {{ person.firstName }} {{ person.lastName }}
                            </option>
                        }
                    </select> -->
                    <!-- </div> -->


                    <!-- If different from above -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Name of person staying at hotel</label>
                        <div class="flex gap-2">
                            <div class="w-1/2">
                                <input type="text" class="w-full bg-white mt-1 border rounded p-2" name="firstName"
                                    placeholder="First Name" [ngModel]="view.bookingForm.firstName">
                            </div>
                            <div class="w-1/2 mt-auto">
                                <input type="text" class="w-full bg-white border rounded p-2" name="lastName"
                                    placeholder="Surname" [ngModel]="view.bookingForm.lastName">
                            </div>
                        </div>
                    </div>

                    <!-- Traveller Position -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Main Traveller, Position in Company
                            *</label>
                        <select class="w-full mt-1 border border-gray-300 text-gray-400 rounded p-2"
                            name="mainTravellerPosition" [ngClass]="{
                            'text-gray-400': view.bookingForm.mainTravellerPosition === '',
                            'text-black': view.bookingForm.mainTravellerPosition !== ''
                            }" [(ngModel)]="view.bookingForm.mainTravellerPosition">
                            <option value="">Select an Option</option>
                            @for(item of mainTravellers; track item) {
                            <option [value]="item.position">
                                {{ item.position }}
                            </option>
                            }
                        </select>
                    </div>

                    <!-- After hours -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Main Traveller After Hours Telephone Number
                            *</label>
                        <input type="text" class="w-full bg-white mt-1 border rounded p-2"
                            [(ngModel)]="view.bookingForm.afterHoursTel" name="afterHoursTel"
                            placeholder="Main Traveller After Hours Telephone Number">
                    </div>

                    <!-- Additional Person -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Name additional person staying at
                            hotel</label>
                        <div class="flex gap-2">
                            <div class="w-1/2">
                                <input type="text" class="w-full bg-white mt-1 border rounded p-2" name="firstName"
                                    placeholder="First Name" [ngModel]="view.bookingForm.additionalPersonFirstNameOne">
                            </div>
                            <div class="w-1/2 mt-auto">
                                <input type="text" class="w-full bg-white border rounded p-2" name="lastName"
                                    placeholder="Surname" [ngModel]="view.bookingForm.additionalPersonLastNameOne">
                            </div>
                        </div>
                    </div>

                    <div>
                        <label class="block text-primary-500 font-semibold">Additional Traveller Position at
                            Company</label>
                        <select class="w-full mt-1 border border-gray-300 text-gray-400 rounded p-2"
                            name="additionalPersonPosition" [ngClass]="{
                            'text-gray-400': view.bookingForm.additionalPersonOnePosition === '',
                            'text-black': view.bookingForm.additionalPersonOnePosition !== ''
                            }" [(ngModel)]="view.bookingForm.additionalPersonOnePosition">
                            <option value="">Select an Option</option>
                            @for(item of mainTravellers; track item) {
                            <option [value]="item.position">
                                {{ item.position }}
                            </option>
                            }
                        </select>
                    </div>

                    <!-- Second additional person -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Name of additional person staying at
                            hotel</label>
                        <div class="flex gap-2">
                            <div class="w-1/2">
                                <input type="text" class="w-full bg-white mt-1 border rounded p-2" name="firstName"
                                    placeholder="First Name" [ngModel]="view.bookingForm.additionalPersonFirstNameTwo">
                            </div>
                            <div class="w-1/2 mt-auto">
                                <input type="text" class="w-full bg-white border rounded p-2" name="lastName"
                                    placeholder="Surname" [ngModel]="view.bookingForm.additionalPersonLastNameTwo">
                            </div>
                        </div>
                    </div>

                    <div>
                        <label class="block text-primary-500 font-semibold">Additional Traveller Position in
                            Company</label>
                        <select class="w-full mt-1 border border-gray-300 text-gray-400 rounded p-2"
                            name="additionalPersonTwoPosition" [ngClass]="{
                            'text-gray-400': view.bookingForm.additionalPersonTwoPosition === '',
                            'text-black': view.bookingForm.additionalPersonTwoPosition !== ''
                            }" [(ngModel)]="view.bookingForm.additionalPersonTwoPosition">
                            <option value="">Select an Option</option>
                            @for(item of mainTravellers; track item) {
                            <option [value]="item.position">
                                {{ item.position }}
                            </option>
                            }
                        </select>
                    </div>

                    <!-- Upload field -->
                    <div class="col-span-1 md:col-span-2">
                        <label class="block text-primary-500 font-semibold mb-1">If more than 3 names staying at hotel
                            please
                            upload a name list and rooming list</label>
                        <div class="border-2 border-dashed border-gray-400 rounded p-4 text-center text-gray-600">
                            Drop your files here
                        </div>
                    </div>

                    <!-- Cell Number -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Your Cell Phone Number *</label>
                        <input type="text" class="w-full mt-1 border rounded p-2" placeholder="Cell Phone Number"
                            name="cell" [(ngModel)]="view.bookingForm.cell">
                    </div>

                    <!-- Email -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Email *</label>
                        <input type="email" class="w-full mt-1 border rounded p-2" placeholder="your@email.com"
                            name="email" [(ngModel)]="view.bookingForm.email">
                    </div>

                    <!-- Room type -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Select room type required *</label>
                        <select class="w-full mt-1 border border-gray-300 rounded p-2" name="roomType" [ngClass]="{
                            'text-gray-400': view.bookingForm.roomType === '',
                            'text-black': view.bookingForm.roomType !== ''
                            }" [(ngModel)]="view.bookingForm.roomType">
                            <option value="">Select a Room Type</option>
                            @for(room of RoomTypes; track room) {
                            <option [value]="room.room">
                                {{ room.room }}
                            </option>
                            }
                        </select>
                    </div>

                    <!-- Other Room Type Description -->
                    <div>
                        <label class="block text-primary-500 font-semibold">If you selected other - Please
                            Describe</label>
                        <input type="text" class="w-full mt-1 border rounded p-2"
                            [(ngModel)]="view.bookingForm.otherRoomType"
                            placeholder="Please describe what room you require">
                    </div>

                    <!-- Number of Rooms -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Number of Rooms *</label>
                        <select class="w-full mt-1 border border-gray-300 rounded p-2" name="numberOfRooms" [ngClass]="{
                            'text-gray-400': view.bookingForm.numberOfRooms === '',
                            'text-black': view.bookingForm.numberOfRooms !== ''
                            }" [(ngModel)]="view.bookingForm.numberOfRooms">
                            <option value="">Select Number of Rooms Type</option>
                            @for(number of numberOfRooms; track number) {
                            <option [value]="number.number">
                                {{ number.number }}
                            </option>
                            }
                        </select>
                    </div>

                    <!-- Check-in -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Check-in Date *</label>
                        <input type="text" class="w-full mt-1 border rounded p-2" placeholder="DD-MM-YYYY"
                            name="checkIn" [(ngModel)]="view.bookingForm.checkIn">
                    </div>

                    <!-- Check-out -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Check-out Date *</label>
                        <input type="text" class="w-full mt-1 border rounded p-2" placeholder="DD-MM-YYYY"
                            name="checkOut" [(ngModel)]="view.bookingForm.checkOut">
                    </div>

                    <!-- Arrival time -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Estimated time of arrival at hotel *</label>
                        <select class="w-full mt-1 border border-gray-300 rounded p-2" name="arrivalTime"
                            [(ngModel)]="view.bookingForm.arrivalTime">
                            <option>Select Item</option>
                        </select>
                    </div>

                    <!-- Meal Plan -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Meal Plan required *</label>
                        <select class="w-full mt-1 border border-gray-300 rounded p-2" name="mealPlan"
                            [(ngModel)]="view.bookingForm.mealPlan">
                            <option>Select Item</option>
                        </select>
                    </div>

                    <!-- Town / City -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Town / City - Establishment Name *</label>
                        <select class="w-full mt-1 border border-gray-300 rounded p-2" name="town"
                            [(ngModel)]="view.bookingForm.town">
                            <option>Select Item</option>
                        </select>
                    </div>

                    <!-- If other, town name -->
                    <div>
                        <label class="block text-primary-500 font-semibold">If selected other please advise town
                            name</label>
                        <input type="text" class="w-full mt-1 border rounded p-2"
                            [(ngModel)]="view.bookingForm.otherTown" name="otherTown"
                            placeholder="Please advise town name">
                    </div>

                    <!-- If other, establishment -->
                    <div>
                        <label class="block text-primary-500 font-semibold">If selected Other please advise
                            establishment
                            name</label>
                        <input type="text" class="w-full mt-1 border rounded p-2"
                            [(ngModel)]="view.bookingForm.otherEstablishment" name="otherEstablishment"
                            placeholder="Establishment Name if not on selection list">
                    </div>

                    <!-- Smoking / Non-smoking -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Smoking / Non-smoking</label>
                        <select class="w-full mt-1 border rounded p-2" [(ngModel)]="view.bookingForm.smoking"
                            name="smoking">
                            <option value="">Select</option>
                            <option value="Smoking">Smoking</option>
                            <option value="Non-smoking">Non-smoking</option>
                        </select>
                    </div>

                    <!-- Other instructions -->
                    <div class="col-span-1 md:col-span-2">
                        <label class="block text-primary-500 font-semibold">Any other instructions</label>
                        <input type="text" class="w-full mt-1 border rounded p-2"
                            [(ngModel)]="view.bookingForm.instructions" name="instructions"
                            placeholder="Please advise what else you require">
                    </div>

                    <!-- Order number -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Order Number *</label>
                        <input type="text" class="w-full mt-1 border rounded p-2"
                            [(ngModel)]="view.bookingForm.orderNumber" name="orderNumber"
                            placeholder="Please complete the order number">
                    </div>

                    <!-- Cost Centre -->
                    <div>
                        <label class="block text-primary-500 font-semibold">Cost Centre *</label>
                        <select class="w-full mt-1 border border-gray-300 rounded p-2"
                            [(ngModel)]="view.bookingForm.costCentre" name="costCentre">
                            <option>Select Item</option>
                        </select>
                    </div>

                    <!-- Terms checkbox -->
                    <div class="col-span-1 md:col-span-2 flex items-center gap-3 mt-4">
                        <input type="checkbox" id="terms" class="w-4 h-4" [(ngModel)]="view.bookingForm.acceptTerms"
                            name="acceptTerms">
                        <label for="terms" class="text-primary-500 font-semibold">I accept standard booking
                            terms</label>
                    </div>

                    <!-- Submit button -->
                    <div class="col-span-1 md:col-span-2 mt-6 text-right">
                        <button type="submit"
                            class="bg-primary-500 hover:bg-primary-800 text-white px-6 py-2 rounded shadow transition-all duration-200">
                            Submit
                        </button>
                    </div>

                </form>
            </div>
        </div>
    </div>
</section>